/** Default filter values for the Daily Attendance & Coverage dashboard. */
export const DASHBOARD_FILTER_DEFAULTS = {
  campaignId: 'all',
  supervisorId: 'all',
  attendanceStatus: 'all',
  coverageStatus: 'all',
  autoRefreshMs: 60_000,
} as const;

export const ALL_FILTER = DASHBOARD_FILTER_DEFAULTS.campaignId;

export function toApiFilterId(id: string): string | undefined {
  return id && id !== ALL_FILTER ? id : undefined;
}

export function isAllFilter(value: string): boolean {
  return !value || value === ALL_FILTER;
}
